module.exports = __webpack_public_path__ + "static/media/karma.baf4feb7.png";